/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolderHierarchy = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 3h4v6H7v2h7V6h4v1h4v6H7v7h7v-5h4v1h4v6H5V9H2V2h4zm10 17h4v-2h-4zm0-9h4V9h-4zM4 7h4V5H4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFolderHierarchy as FolderHierarchy };
